/* eslint-disable class-methods-use-this */
/* eslint-disable no-invalid-this */

const React = require('react');
const wrapComponentRender = require('utils/framework/wrapComponentRender').default;

class BaseClass extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate = wrapComponentRender().shouldComponentUpdate;
}

BaseClass.class = 'BaseClass';

module.exports = BaseClass;
